import type { EventSettings } from '../types';

export const FOLLOW_PREFERENCE_KEY = 'panther-2026:follow-presenter';
export const FOLLOW_COUNTDOWN_SECONDS = 5;

export interface FollowChange {
  topicId: string;
  deferredForDraft: boolean;
}

export function readFollowPreference(storage: Pick<Storage, 'getItem'>): boolean {
  return storage.getItem(FOLLOW_PREFERENCE_KEY) !== 'false';
}

export function writeFollowPreference(
  storage: Pick<Storage, 'setItem'>,
  enabled: boolean,
): void {
  storage.setItem(FOLLOW_PREFERENCE_KEY, String(enabled));
}

export function topicIdFromPath(pathname: string): string | null {
  const match = /^\/topics\/([^/]+)\/?$/.exec(pathname);
  return match ? decodeURIComponent(match[1]) : null;
}

export function topicPath(topicId: string): string {
  return `/topics/${encodeURIComponent(topicId)}`;
}

export function shouldReturnToTopicList(
  previousBrowsingEnabled: boolean | null,
  nextBrowsingEnabled: boolean,
): boolean {
  return previousBrowsingEnabled === false && nextBrowsingEnabled;
}

export function detectFollowChange(
  previous: EventSettings | null,
  next: EventSettings,
  options: {
    pathname: string;
    localFollowEnabled: boolean;
    hasCommentDraft: boolean;
  },
): FollowChange | null {
  const currentPathTopicId = topicIdFromPath(options.pathname);
  const isFollowableRoute =
    options.pathname === '/' ||
    options.pathname === '/leaderboard' ||
    currentPathTopicId !== null;
  if (
    !previous ||
    !isFollowableRoute ||
    !options.localFollowEnabled ||
    !next.audienceFollowEnabled ||
    !next.currentTopicId ||
    previous.currentTopicChangedAt === next.currentTopicChangedAt ||
    currentPathTopicId === next.currentTopicId
  ) {
    return null;
  }

  return {
    topicId: next.currentTopicId,
    deferredForDraft: options.hasCommentDraft,
  };
}

export function countdownSeconds(deadline: number, now: number): number {
  return Math.max(0, Math.ceil((deadline - now) / 1_000));
}
